(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["detail-before-after"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('detail-before-after-component')) {
    class DetailBeforeAfterSection extends HTMLElement {
      connectedCallback() {
        // A registered custom element can connect before its children are parsed.
        this.contentObserver?.disconnect();
        this.contentObserver = new MutationObserver(() => this.initialize());
        this.contentObserver.observe(this, { childList: true, subtree: true });
        this.initialize();
      }

      initialize() {
        if (!this.isConnected) return;
        if (this.isInitialized) return;

        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        const expectedCount = Number(this.dataset.blockCount);
        if (!expectedCount) {
          this.contentObserver?.disconnect();
          return;
        }
        if (this.tabs.length !== expectedCount || this.panels.length !== expectedCount) return;

        this.contentObserver?.disconnect();
        this.isInitialized = true;
        this.activeIndex = Math.max(
          0,
          this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')
        );
        this.transitionDuration = Number(this.dataset.transitionDuration) || 650;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.controlsElement = this.querySelector('.detail-before-after__controls');
        this.previousArrow = this.querySelector('[data-step="-1"]');
        this.nextArrow = this.querySelector('[data-step="1"]');
        this.switchTimer = null;
        this.tabScrollTimer = null;

        this.onClick = (event) => {
          const arrow = event.target.closest('[data-step]');
          if (arrow && this.contains(arrow)) {
            this.select(this.activeIndex + Number(arrow.dataset.step));
            return;
          }

          const tab = event.target.closest('[role="tab"]');
          if (!tab || !this.contains(tab)) return;
          this.select(Number(tab.dataset.index));
        };

        this.onKeydown = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab) return;

          const currentIndex = Number(tab.dataset.index);
          let nextIndex = currentIndex;

          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % this.tabs.length;
          } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
            nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = this.tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          this.select(nextIndex);
          this.tabs[nextIndex]?.focus({ preventScroll: true });
        };

        this.onBlockSelect = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab) return;
          this.select(Number(tab.dataset.index));
        };

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.ensureActiveTabVisible('auto'));
          this.resizeObserver.observe(this);
        }
        this.panels.forEach((panel, index) => {
          panel.hidden = index !== this.activeIndex;
          panel.classList.toggle('is-active', index === this.activeIndex);
          panel.classList.remove('is-entering', 'is-leaving');
        });
        this.updateArrowStates();
        this.setupScrollReveal();
      }

      disconnectedCallback() {
        this.contentObserver?.disconnect();
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
        this.revealObserver?.disconnect();
        window.clearTimeout(this.switchTimer);
        window.clearTimeout(this.tabScrollTimer);
        this.isInitialized = false;
      }

      setupScrollReveal() {
        if (this.dataset.scrollAnimation === 'none' || this.reducedMotion || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }

        this.classList.add('is-animation-ready');
        this.revealObserver = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this.classList.add('is-visible');
            this.revealObserver.disconnect();
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
        );
        this.revealObserver.observe(this);
      }

      updateArrowStates() {
        if (this.previousArrow) this.previousArrow.disabled = this.activeIndex <= 0;
        if (this.nextArrow) this.nextArrow.disabled = this.activeIndex >= this.tabs.length - 1;
      }

      ensureActiveTabVisible(behavior = 'smooth') {
        if (!window.matchMedia('(max-width: 989px)').matches || !this.controlsElement) return;

        const activeTab = this.tabs[this.activeIndex];
        if (!activeTab) return;

        const controlsRect = this.controlsElement.getBoundingClientRect();
        const activeRect = activeTab.getBoundingClientRect();
        const activeLeft = activeRect.left - controlsRect.left + this.controlsElement.scrollLeft;
        const left =
          activeTab.clientWidth >= this.controlsElement.clientWidth
            ? activeLeft
            : activeLeft - (this.controlsElement.clientWidth - activeTab.clientWidth) / 2;
        this.controlsElement.scrollTo({ left: Math.max(0, left), behavior: this.reducedMotion ? 'auto' : behavior });
      }

      select(nextIndex) {
        if (!Number.isInteger(nextIndex) || nextIndex < 0 || nextIndex >= this.tabs.length) return;
        if (nextIndex === this.activeIndex) return;

        const previousIndex = this.activeIndex;
        const previousPanel = this.panels[previousIndex];
        const nextPanel = this.panels[nextIndex];
        if (!previousPanel || !nextPanel) return;

        window.clearTimeout(this.switchTimer);
        this.dataset.direction = nextIndex > previousIndex ? 'forward' : 'backward';

        this.tabs.forEach((tab, index) => {
          const isActive = index === nextIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
          tab.querySelector('.detail-before-after__tab-copy')?.setAttribute('aria-hidden', String(!isActive));
        });

        this.panels.forEach((panel, index) => {
          panel.classList.remove('is-entering', 'is-leaving');
          if (index !== previousIndex && index !== nextIndex) panel.hidden = true;
        });

        nextPanel.hidden = false;
        nextPanel.querySelector('img')?.setAttribute('loading', 'eager');
        void nextPanel.offsetWidth;

        if (this.reducedMotion) {
          previousPanel.hidden = true;
          previousPanel.classList.remove('is-active');
          nextPanel.classList.add('is-active');
        } else {
          previousPanel.classList.remove('is-active');
          previousPanel.classList.add('is-leaving');
          nextPanel.classList.add('is-active', 'is-entering');

          this.switchTimer = window.setTimeout(() => {
            previousPanel.hidden = true;
            previousPanel.classList.remove('is-leaving');
            nextPanel.classList.remove('is-entering');
          }, this.transitionDuration);
        }

        this.activeIndex = nextIndex;
        this.updateArrowStates();

        this.ensureActiveTabVisible();
        window.clearTimeout(this.tabScrollTimer);
        this.tabScrollTimer = window.setTimeout(() => this.ensureActiveTabVisible(), 480);
      }
    }

    customElements.define('detail-before-after-component', DetailBeforeAfterSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-skin-goals"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('skin-goals')) {
    customElements.define(
      'skin-goals',
      class SkinGoals extends HTMLElement {
        constructor() {
          super();
          this.handleScroll = this.handleScroll.bind(this);
          this.handleResize = this.handleResize.bind(this);
          this.handlePrevious = () => this.move(-1);
          this.handleNext = () => this.move(1);
        }

        connectedCallback() {
          this.track = this.querySelector('[data-skin-goals-track]');
          this.cards = [...this.querySelectorAll('[data-skin-goals-card]')];
          this.previousButton = this.querySelector('[data-skin-goals-previous]');
          this.nextButton = this.querySelector('[data-skin-goals-next]');

          if (!this.track || this.cards.length < 2 || !this.previousButton || !this.nextButton) return;

          this.previousButton.addEventListener('click', this.handlePrevious);
          this.nextButton.addEventListener('click', this.handleNext);
          this.track.addEventListener('scroll', this.handleScroll, { passive: true });
          window.addEventListener('resize', this.handleResize, { passive: true });
          this.updateControls();
        }

        disconnectedCallback() {
          this.track?.removeEventListener('scroll', this.handleScroll);
          this.previousButton?.removeEventListener('click', this.handlePrevious);
          this.nextButton?.removeEventListener('click', this.handleNext);
          window.removeEventListener('resize', this.handleResize);
          cancelAnimationFrame(this.scrollFrame);
        }

        handleScroll() {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateControls());
        }

        handleResize() {
          if (window.matchMedia('(min-width: 750px)').matches) this.track.scrollLeft = 0;
          this.updateControls();
        }

        currentIndex() {
          const firstCardOffset = this.cards[0].offsetLeft;

          return this.cards.reduce((closestIndex, card, index) => {
            const currentDistance = Math.abs(card.offsetLeft - firstCardOffset - this.track.scrollLeft);
            const closestDistance = Math.abs(
              this.cards[closestIndex].offsetLeft - firstCardOffset - this.track.scrollLeft
            );
            return currentDistance < closestDistance ? index : closestIndex;
          }, 0);
        }

        move(direction) {
          const targetIndex = Math.max(0, Math.min(this.cards.length - 1, this.currentIndex() + direction));
          const targetPosition = this.cards[targetIndex].offsetLeft - this.cards[0].offsetLeft;
          this.track.scrollTo({ left: targetPosition, behavior: 'smooth' });
        }

        updateControls() {
          if (!this.track || !this.previousButton || !this.nextButton) return;

          const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          this.previousButton.disabled = this.track.scrollLeft <= 2;
          this.nextButton.disabled = this.track.scrollLeft >= maximumScroll - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
